import React, { SyntheticEvent } from "react";
import { Component } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";

import { ObjectLiteral } from "../../constants";
import { Props, registrationType } from "../propTypes";
import { childFormComponent } from "./types";
import queryString from "query-string";
import classnames from "classnames";
import { ProgressIndicator } from "./ProgressIndicator";
import { withCookies } from "react-cookie";
import { ResetForm } from "./ResetForm";

// Campus Form Component
/**
 * This component is used to input and store a user's campus information in MyElevation.
 *
 * We are using the Form and Button components from Semantic UI React Library.
 * For more information on these components can be found at https://react.semantic-ui.com/collections/form/
 * and https://react.semantic-ui.com/elements/button/
 *
 * The campus values are being pulled from this.props.actions.main.main_get_all_campuses().
 * Check this action and the api calls set up within them if you run into any problems.
 */

type State = {
    campus: string;
    campusFocused: boolean;
};

class Campus extends Component<Props & childFormComponent, State> {
    state = {
        campus: "",
        campusFocused: false,
    };

    // Component Did Mount Lifecycle Method
    /**
     * componentDidMount() runs immediately after the component mounts.
     */
    componentDidMount() {
        if (
            !this.props.main.campuses ||
            (this.props.main.campuses && this.props.main.campuses.length < 1)
        ) {
            this.props.actions.main.main_get_all_campuses();
        }

        let campus: string = "";

        if (
            this.props.registrationType === registrationType.eTeam ||
            this.props.registrationType === registrationType.eLeader ||
            this.props.registrationType === registrationType.Baptism ||
            this.props.registrationType === registrationType.Salvation ||
            this.props.registrationType === registrationType.event
        ) {
            campus = (this.props.selectedCampusId as string) || "";
        }

        if (this.props.registrationType === registrationType.eGroup) {
            const parsedQuerystring = this.props.router?.query;

            if (parsedQuerystring && parsedQuerystring.campus) {
                campus = parsedQuerystring.campus as string;
            }
        }

        if (campus) {
            this.props.handleChange("campus")(null, campus);
        }

        this.setState({
            campus,
        });
    }

    handleChange = (value: string) => {
        this.setState({
            campus: value,
        });

        this.props.handleChange("campus")(null, value);
    };

    // Save and Continue Function
    /**
     * saveAndContinue() saves the values to the state and goes to the corresponding next step.
     */
    saveAndContinue = (e: any) => {
        e.preventDefault();
        this.props.main.campuses.forEach((campus: ObjectLiteral) => {
            if (this.state.campus === campus.id) {
                this.props.handleChange("campusName")(null, campus.name);
            }
        });
        this.props.nextStep(6);
    };

    render() {
        return (
            <>
                <div className="col-xs-12 max-w-500 center-content m-b-spacer-3xl full-width">
                    <h2 className="text-dark text-left m-b-spacer-none text-center">
                        Choose your campus community.
                    </h2>

                    <Form className="p-y-spacer-xl">
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg",
                                {
                                    filled:
                                        this.state.campus ||
                                        this.state.campusFocused,
                                }
                            )}
                        >
                            <label style={{ zIndex: 2 }}>Campus</label>
                            <Dropdown
                                clearable
                                fluid
                                search
                                selection
                                selectOnBlur={false}
                                selectOnNavigation={false}
                                options={[
                                    {
                                        key: "dummy-option-fix-autoselection",
                                        text: "",
                                        value: "",
                                        className: "hide",
                                    },
                                    ...this.props.main.campuses
                                        // .filter(
                                        //     (campus) =>
                                        //         campus.id !== "" &&
                                        //         campus.id !==
                                        //             "a0n4600000R5r7XAAR"
                                        // )
                                        .map((campus) => {
                                            return {
                                                key: campus.id,
                                                text: campus.name,
                                                value: campus.id,
                                            };
                                        }),
                                ]}
                                onChange={(
                                    event: SyntheticEvent,
                                    data: ObjectLiteral
                                ) => {
                                    this.handleChange(data.value);

                                    if (!data.value) {
                                        this.setState({
                                            campusFocused: false,
                                        });
                                    }
                                }}
                                onClick={() => {
                                    this.setState({ campusFocused: true });
                                }}
                                onBlur={() => {
                                    this.setState({ campusFocused: false });
                                }}
                                disabled={
                                    this.props.main.campuses.length < 1 ||
                                    this.props.main.isLoading
                                }
                                onFocus={(e) => {
                                    (e.target as any).setAttribute(
                                        "autocomplete",
                                        "nope"
                                    );
                                }}
                                value={this.state.campus}
                                className="p-x-spacer-md ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                name="campus"
                            />
                        </Form.Field>

                        {this.props.values.isLoading ? (
                            <div className="form-loading rel-pos  m-t-spacer-md  way-forward full-width uptop">
                                <div className="la-ball-clip-rotate la-color la-md loading-spin abs-pos absolute-center">
                                    <div />
                                </div>
                            </div>
                        ) : (
                            <Button
                                className="full-width no-border text-white  p-y-spacer-md uppercase let-sp-reg hover-grow ec-border-radius"
                                onClick={this.saveAndContinue}
                                disabled={!this.state.campus}
                                id={`${this.props.tagPrefixId}-campus-next`}
                            >
                                Next
                            </Button>
                        )}
                    </Form>
                    <ProgressIndicator currentStep={7} />
                </div>
                <ResetForm
                    idPrefix={`${this.props.tagPrefixId}-campus`}
                    cancelUrl={this.props.cancelUrl || ""}
                />
            </>
        );
    }
}

export default withCookies(Campus);
